import type { BaseEditor, Editor } from 'slate'
import { Node, Text } from 'slate'
import type { Decorator } from '../useDecorations'

export type Props = {
  decorators: Decorator[]
}

export type UseInitalizer = (props: Props) => Props

// Plugins can have an Init component
export type EditorWithInitializablePlugins = {
  useInitializer: UseInitalizer
}

export function withInit<T extends BaseEditor>(editor: T) {
  const e = editor as T & Editor

  e.useInitializer = function defaultUseInitializer(props) {
    return props
  }

  const { getMarks } = e
  e.getMarks = () => {
    const { selection } = e
    if (selection) {
      try {
        const node = Node.get(e, selection.focus.path)
        // If the focus path points to a non-text node (e.g. list-item on initial load),
        // marks are undefined rather than causing a crash.
        if (!Text.isText(node)) {
          return null
        }
      } catch {
        return null
      }
    }
    try {
      return getMarks()
    } catch {
      return null
    }
  }

  return e
}
